import { render } from "./ComplianceGraphQLMediatorAPI.vue?vue&type=template&id=50738056&scoped=true"
import script from "./ComplianceGraphQLMediatorAPI.vue?vue&type=script&lang=js"
export * from "./ComplianceGraphQLMediatorAPI.vue?vue&type=script&lang=js"

import "./ComplianceGraphQLMediatorAPI.vue?vue&type=style&index=0&id=50738056&lang=css"
import "./ComplianceGraphQLMediatorAPI.vue?vue&type=style&index=1&id=50738056&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50738056"]])

export default __exports__